import React, { PropsWithChildren } from 'react';
import Authority from '@app/model/authentication/Authority';
import ACLAuthority from '@app/model/profile/ACLAuthority';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';
import useSecurity from '@util/SecurityHook';

interface Props {
    hasAnyAuthority: Authority[]
    hasAclAuthority?: ACLAuthority
}

const SecuredFragment: React.FunctionComponent<PropsWithChildren<Props>> = ({
                                                                                children,
                                                                                hasAnyAuthority,
                                                                                hasAclAuthority
                                                                            }) => {
    const security = useSecurity();
    const { companyHotel } = useSelectedCompanyHotel();

    return (
        <React.Fragment>
            {!hasAclAuthority && security.hasAnyAuthority(hasAnyAuthority) && <React.Fragment>{children}</React.Fragment>}
            {!!hasAclAuthority && (security.hasAnyAuthority(hasAnyAuthority) || security.hasAclAuthority(companyHotel, hasAclAuthority)) && <React.Fragment>{children}</React.Fragment>}
        </React.Fragment>
    );

};

export default SecuredFragment;
